<template>
  <div :class="componentClassName">
    <a-page-heading>Salesforce連携設定</a-page-heading>
    <m-section variant="fullpage">
      <m-action-card title="連携先の項目設定" header-border no-header-margin icon="user">
        <form ref="form" class="t-setting-other__form">
          <div class="t-setting-other__fields">
            <m-form-input label="SalesforceのログインURL">
              <a-text-field id="sfLoginUrl" v-model="formData.sfLoginUrl" type="text" maxlength="255" />
            </m-form-input>
            <m-form-input label="SalesforceのレコードURL">
              <a-text-field id="sfDomainName" v-model="formData.sfDomainName" type="text" maxlength="255" />
            </m-form-input>
            <a-caption-list>
              <li>{{ sfDomainCaption }}</li>
            </a-caption-list>
            <m-form-input label="連携先テーブル">
              <a-select-field id="sfTable" v-model="formData.sfTable" :options="sfTableOptions" />
            </m-form-input>
            <!--
            <m-form-input label="COTOHA Call Center通話履歴キーの連携ON/OFF">
              <a-checkbox id="sfColumnCallSidFlag" v-model="formData.sfColumnCallSidFlag" label="有効" />
            </m-form-input>
            <m-form-input label="COTOHA Call Center通話履歴キーの連携先項目名">
              <a-text-field
                id="sfColumnCallSid"
                v-model="formData.sfColumnCallSid"
                type="text"
                maxlength="255"
                :disabled="!formData.sfColumnCallSidFlag"
              />
            </m-form-input>
            -->
            <m-form-input label="Salesforce情報の着信ポップアップ">
              <a-checkbox id="sfContactAvailable" v-model="formData.sfContactAvailable" label="有効" /><br />
            </m-form-input>
            <a-caption-list>
              <li>{{ sfContactCaption }}</li>
              <br />
            </a-caption-list>
            <m-form-input label="電話番号連携の有効化">
              <a-checkbox id="sfColumnPhoneNumberFlag" v-model="formData.sfColumnPhoneNumberFlag" label="有効" />
            </m-form-input>
            <m-form-input label="電話番号の連携先項目名">
              <a-text-field
                id="sfColumnPhoneNumber"
                v-model="formData.sfColumnPhoneNumber"
                type="text"
                maxlength="255"
                :disabled="!formData.sfColumnPhoneNumberFlag"
              />
            </m-form-input>
            <m-form-input label="オペレータ名連携の有効化">
              <a-checkbox id="sfColumnOperatorFlag" v-model="formData.sfColumnOperatorFlag" label="有効" />
            </m-form-input>
            <m-form-input label="オペレータ名の連携先項目名">
              <a-text-field
                id="sfColumnOperator"
                v-model="formData.sfColumnOperator"
                type="text"
                maxlength="255"
                :disabled="!formData.sfColumnOperatorFlag"
              />
            </m-form-input>
            <m-form-input label="通話メモ連携の有効化">
              <a-checkbox id="sfColumnMemoFlag" v-model="formData.sfColumnMemoFlag" label="有効" />
            </m-form-input>
            <m-form-input label="通話メモの連携先項目名">
              <a-text-field
                id="sfColumnMemo"
                v-model="formData.sfColumnMemo"
                type="text"
                maxlength="255"
                :disabled="!formData.sfColumnMemoFlag"
              />
            </m-form-input>
            <a-caption-list>
              <li>{{ sfCallMemoCaption }}</li>
            </a-caption-list>
            <m-form-input label="通話録音リンク連携の有効化">
              <a-checkbox id="sfColumnRecordingFlag" v-model="formData.sfColumnRecordingFlag" label="有効" />
            </m-form-input>
            <m-form-input label="通話録音リンクの連携先項目名">
              <a-text-field
                id="sfColumnRecording"
                v-model="formData.sfColumnRecording"
                type="text"
                maxlength="255"
                :disabled="!formData.sfColumnRecordingFlag"
              />
            </m-form-input>
            <m-form-action-buttons>
              <a-button id="save-button" variant="block" color="primary" @click="handleSaveSfSetting"> 保存 </a-button>
            </m-form-action-buttons>
          </div>
        </form>
      </m-action-card>
      <m-action-card title="連携機能のテスト" header-border no-header-margin icon="user">
        <form ref="form" class="t-setting-other__form">
          <div class="t-setting-other__fields">
            <m-form-input label="連携設定について">
              <a-caption-list>
                <li>
                  連携機能テストの前に、現在このブラウザでログインしているユーザーに対して
                  <a-button id="idmgmtLink" variant="text" color="primary" target="_blank" :href="'/idmgmt'">
                    ユーザー管理
                  </a-button>
                  からSalesforceログイン情報を登録してください。
                </li>
              </a-caption-list>
            </m-form-input>
            <m-form-input label="件名">
              <a-text-field id="sfSubjectTest" v-model="testSfRecord.sfSubject" type="text" maxlength="255" />
            </m-form-input>
            <m-form-input label="電話番号">
              <a-text-field id="sfPhoneNumberTest" v-model="testSfRecord.sfPhoneNumber" type="text" maxlength="255" />
            </m-form-input>
            <!--
            <m-form-input label="COTOHA Call Center通話履歴キー">
              <a-text-field id="sfCallSidTest" v-model="testSfRecord.sfCallSid" type="text" maxlength="255" />
            </m-form-input>
            -->
            <m-form-input label="通話メモ">
              <a-text-field id="sfMemoTest" v-model="testSfRecord.sfMemo" type="text" maxlength="255" />
            </m-form-input>
            <m-form-input label="通話録音リンク">
              <a-text-field id="sfRecordingTest" v-model="testSfRecord.sfRecording" type="text" maxlength="255" />
            </m-form-input>
            <m-form-input label="対応オペレータ名">
              <a-text-field id="sfOperator" v-model="testSfRecord.sfOperator" type="text" maxlength="255" />
            </m-form-input>
            <m-form-action-buttons>
              <a-button
                v-if="!sfCreateTestProcessing"
                id="testCreateSfRecordButton"
                variant="block"
                color="primary"
                @click="handleTestCreateSfRecord"
              >
                テスト実行
              </a-button>
              <a-button
                v-if="sfCreateTestProcessing"
                id="testCreateSfRecordButtonDisabled"
                variant="block"
                color="primary"
                disabled
              >
                テスト実行中...
              </a-button>
            </m-form-action-buttons>
          </div>
        </form>
      </m-action-card>
    </m-section>
  </div>
  <teleport to="body">
    <o-modal
      id="ContractEditSfSetting_resultModal"
      :visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button id="ok" variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import MSection from '@/components/molecules/section';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import AButton from '@/components/atoms/button';
import MFormInput from '@/components/molecules/form-input';
import ATextField from '@/components/atoms/text-field';
import ACaptionList from '@/components/atoms/caption-list';
import { cloneDeep } from 'lodash';
import { IDENTIFICATION_OPTIONS } from '@/libs/constants';

import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { PREFECTURES } from '@/libs/constants';
import { POINT } from '@/libs/constants';

import { customValidate } from '@/common/customValidate.js'; // #2456

// For Trial
import { utils } from '@/common/utils.js';

export default {
  name: 't-contract-edit-sf-setting',
  components: {
    APageHeading,
    MActionCard,
    MSection,
    MFormActionButtons,
    AButton,
    MFormInput,
    ATextField,
    ACaptionList,
  },
  mixins: [customRequest, messageContent, customValidate], // #2456

  props: {
    class: {
      type: String,
      default: '',
    },
    handleSaveClick: {
      type: Function,
      default: () => {},
    },
    companyID: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      selectedCompanyID: '',
      companyIDList: [],
      POINT,
      authInfo: this.$store.state.user.authInfo, // #2328
      prefectures: [],
      formData: {
        sfAvailable: false,
        sfLoginUrl: '',
        sfDomainName: '',
        sfTable: 'Case',
        sfColumnPhoneNumber: '',
        sfColumnPhoneNumberFlag: false,
        sfColumnCallSid: '',
        sfColumnCallSidFlag: false,
        sfColumnMemo: '',
        sfColumnMemoFlag: false,
        sfColumnRecording: '',
        sfColumnRecordingFlag: false,
        sfContactAvailable: false,
        sfColumnOperator: '',
        sfColumnOperatorFlag: false,
      },
      formOrgData: {},
      contractStatusFlag: false,
      soStatusFlag: false,
      sfTableOptions: [
        {
          label: 'ケース',
          value: 'Case',
        },
        {
          label: '活動履歴',
          value: 'Task',
        },
      ],
      testSfRecord: {
        sfSubject: '',
        sfPhoneNumber: '',
        sfCallSid: '',
        sfMemo: '',
        sfRecording: '',
        sfOperator: '',
      },
      sfCreateTestProcessing: false,
      sfContactOptions: [
        {
          label: 'COTOHA Call Centerの連絡先',
          value: 'ccc',
        },
        {
          label: 'Salesforceの取引先責任者(連絡先)',
          value: 'sf',
        },
      ],
      sfCallMemoCaption:
        '通話メモ連携がONの場合、通話メモの閲覧・編集はSalesforce上で行ってください。(COTOHA Call Centerの通話履歴画面上から通話メモを編集することはできません)',
      sfContactCaption:
        '有効にした場合、通話着信時にSalesforceの連絡先情報(取引先責任者)が取得されて着信ポップアップに表示されます。',
      sfDomainCaption:
        'Salesforceのケースまたは活動履歴のレコードURLを入力してください。また、URLのレコードID部分は半角英字の「(id)」という文字列にしてください。',
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-contract-edit-sf-setting');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  watch: {
    selectedCompanyID: async function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        // 連続に2回ルーターpushするのを禁止する #2427
        if (this.companyID === POINT && this.selectedCompanyID !== this.$route.query.companyID) {
          await this.$router.push({ query: { companyID: this.selectedCompanyID } });
        }
        if (!utils.chkTrialCompanyID(this.companyID)) {
          this.fetchContractDataHandler();
        }
      }
      if (!newValue) {
        this.selectedCompanyID = oldValue;
      }
    },
  },
  async created() {
    this.selectedCompanyID = this.$route.query.companyID ? this.$route.query.companyID : this.companyID;
    // #2328
    let invalidFlag = false;
    // soOperatorはメニューではねている=改竄されている
    if (this.authInfo === 'soOperator') {
      invalidFlag = true;
    }
    // POINT以外でログインした企業ID以外が指定されてきた=企業IDが改竄されている
    if (this.companyID !== POINT && this.selectedCompanyID !== this.companyID) {
      invalidFlag = true;
    }
    // POINT以外でかつ権限が(manager||operator)=メニューではねられるはずなので改竄疑い
    if (this.companyID !== POINT && this.authInfo === 'operator') {
      invalidFlag = true;
    }
    // ログインがPOINTかつPOINT選択はsupervisor以外できないはず=改竄疑い
    if (
      this.companyID === POINT &&
      this.selectedCompanyID === POINT &&
      (this.authInfo === 'manager' || this.authInfo === 'operator')
    ) {
      invalidFlag = true;
    }
    // For Trial
    if (
      utils.chkTrialCompanyID(this.companyID) ||
      (this.companyID === POINT && utils.chkTrialCompanyID(this.selectedCompanyID))
    ) {
      invalidFlag = true;
    }
    if (invalidFlag === true) {
      this.$router.push({ path: '/permission-denied' });
      return;
    }

    if (this.companyID === POINT) {
      await this.fetchCompanyIDListHandler();
    }
    this.prefectures = PREFECTURES;

    window.scrollTo(0, 0);
  },
  methods: {
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    handleSaveSfSetting() {
      // チェック有効の連携先項目バリデーション
      const errorColumn = [];
      if (this.formData.sfColumnPhoneNumberFlag === true && !this.formData.sfColumnPhoneNumber) {
        errorColumn.push('電話番号');
      }
      if (this.formData.sfColumnOperatorFlag === true && !this.formData.sfColumnOperator) {
        errorColumn.push('オペレータ名');
      }
      if (this.formData.sfColumnMemoFlag === true && !this.formData.sfColumnMemo) {
        errorColumn.push('通話メモ');
      }
      if (this.formData.sfColumnRecordingFlag === true && !this.formData.sfColumnRecording) {
        errorColumn.push('通話録音リンク');
      }

      // 空白の項目があればエラー
      if (errorColumn.length > 0) {
        const errorColumnStr = errorColumn.join('、');
        this.showErrorModal(messageContent.notSetSfColumnSettings(errorColumnStr));
        return;
      } else {
        const sendData = {
          sfLoginUrl: this.formData.sfLoginUrl,
          sfDomainName: this.formData.sfDomainName,
          sfTable: this.formData.sfTable,
          sfColumnPhoneNumber: this.formData.sfColumnPhoneNumber,
          sfColumnPhoneNumberFlag: this.formData.sfColumnPhoneNumberFlag,
          sfColumnCallSid: this.formData.sfColumnCallSid,
          sfColumnCallSidFlag: this.formData.sfColumnCallSidFlag,
          sfColumnMemo: this.formData.sfColumnMemo,
          sfColumnMemoFlag: this.formData.sfColumnMemoFlag,
          sfColumnRecording: this.formData.sfColumnRecording,
          sfColumnRecordingFlag: this.formData.sfColumnRecordingFlag,
          sfContactAvailable: this.formData.sfContactAvailable,
          sfColumnOperator: this.formData.sfColumnOperator,
          sfColumnOperatorFlag: this.formData.sfColumnOperatorFlag,
        };
        this.postRequest('/contract/setSfSetting', {
          sendData: sendData,
          selectedCompanyID: this.selectedCompanyID,
        })
          .then(e => {
            if (e.status === 'success') {
              this.showInfoModal(messageContent.sfSettingsSaveComplete);
              return;
            } else {
              if (e.msg !== '') {
                this.showErrorModal(e.msg);
                return;
              } else {
                this.showErrorModal(messageContent.sfSettingsSaveError);
                return;
              }
            }
          })
          .catch(() => {
            this.showErrorModal(messageContent.sfSettingsSaveError);
            return;
          });
      }
    },
    fetchContractDataHandler: async function () {
      await this.postRequest('/contract/getcontractdata', {
        companyID: this.companyID === POINT ? this.$route.query.companyID : this.companyID,
      })
        .then(e => {
          this.formData.sfAvailable = e.data.sfAvailable || '';
          this.formData.sfLoginUrl = e.data.sfLoginUrl || '';
          this.formData.sfDomainName = e.data.sfDomainName || '';
          this.formData.sfTable = e.data.sfTable || 'Case';
          this.formData.sfColumnPhoneNumber = e.data.sfColumnPhoneNumber || '';
          this.formData.sfColumnPhoneNumberFlag = e.data.sfColumnPhoneNumberFlag || false;
          this.formData.sfColumnCallSid = e.data.sfColumnCallSid || '';
          this.formData.sfColumnCallSidFlag = e.data.sfColumnCallSidFlag || false;
          this.formData.sfColumnMemo = e.data.sfColumnMemo || '';
          this.formData.sfColumnMemoFlag = e.data.sfColumnMemoFlag || false;
          this.formData.sfColumnRecording = e.data.sfColumnRecording || '';
          this.formData.sfColumnRecordingFlag = e.data.sfColumnRecordingFlag || false;
          this.formData.sfContactAvailable = e.data.sfContactAvailable || false;
          this.formData.sfColumnOperator = e.data.sfColumnOperator || '';
          this.formData.sfColumnOperatorFlag = e.data.sfColumnOperatorFlag || false;
          if (e.data.contractStatus === 'close') {
            this.contractStatusFlag = true;
            this.showErrorModal(messageContent.alertNowCanceling());
          }
          this.formOrgData = cloneDeep(this.formData);

          // Salesforce連携機能がOFFであれば403
          if (this.formData.sfAvailable !== true) {
            this.$router.push({ path: '/permission-denied' });
            return;
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('契約者情報取得'));
        });
    },
    fetchCompanyIDListHandler: function () {
      this.postRequest('/companymgmt/getcompanyidlist')
        .then(e => {
          this.companyIDList = e.data;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('企業一覧の取得'));
        });
    },
    handleTestCreateSfRecord: async function () {
      this.sfCreateTestProcessing = true;
      await this.postRequest('/contract/testCreateSfRecord', {
        selectedCompanyID: this.selectedCompanyID,
        testSfRecord: this.testSfRecord,
      })
        .then(e => {
          this.sfCreateTestProcessing = false;
          if (e.status === 'success') {
            this.showInfoModal(messageContent.sfCreateTestRecordComplete);
          } else if (e.status === 'fail') {
            let errorMessage = '';
            if (e.message) {
              errorMessage = messageContent.sfCreateTestRecordError(e.message);
            } else {
              errorMessage = messageContent.sfCreateTestRecordErrorText;
            }
            this.showErrorModal(errorMessage);
          }
        })
        .catch(err => {
          this.sfCreateTestProcessing = false;
          console.error(err);
          this.showErrorModal(messageContent.sfCreateTestRecordErrorText);
        });
    },
  },
};
</script>
